const UI = require("./ui").default;

var app = new UI();
var rs = document.readyState;
if (rs === "interactive" || rs === "complete") {
    app.run();
} else {
    document.addEventListener("readystatechange", () => {
        if (document.readyState === "interactive") {
            app.run()
        }
    })
}